// Centralized app configuration with fallback defaults.
// Values are read from environment variables first; if not present, fallbacks are used.

const config = {
  SERVER_BASE_URL:
    process.env.REACT_APP_SERVER_BASE_URL,

  MAP_CENTER_LAT:
    +(process.env.REACT_APP_MAP_CENTER_LAT),

  MAP_CENTER_LNG:
    +(process.env.REACT_APP_MAP_CENTER_LNG),

  GOOGLE_API_KEY:
    process.env.REACT_APP_GOOGLE_API_KEY,

  FLEET_ENGINE_PROJECT_ID:
    process.env.REACT_APP_FLEET_ENGINE_PROJECT_ID,

  SOCKET_URL:
    process.env.REACT_APP_SOCKET_URL,

  MQTT_BROKER:
    process.env.REACT_APP_MQTT_BROKER,

  MQTT_TOPIC:
    process.env.REACT_APP_MQTT_TOPIC,

  MQTT_PORT:
    +(process.env.REACT_APP_MQTT_PORT),

  MQTT_USERNAME:
    process.env.REACT_APP_MQTT_USERNAME,

  MQTT_PASSWORD:
    process.env.REACT_APP_MQTT_PASSWORD,

  WEBSOCKET_SERVER_BASE_URL:
    process.env.REACT_APP_WEBSOCKET_SERVER_BASE_URL,
};

export default config;
